import { render, staticRenderFns } from "./BrandsList.vue?vue&type=template&id=b7e37c56&scoped=true&"
import script from "./BrandsList.vue?vue&type=script&lang=js&"
export * from "./BrandsList.vue?vue&type=script&lang=js&"
import style0 from "./BrandsList.vue?vue&type=style&index=0&id=b7e37c56&lang=scss&scoped=true&"
import style1 from "./BrandsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7e37c56",
  null
  
)

export default component.exports